
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import WTPPumpMasterPagePopup from './WTPPumpMasterPagePopup'
import Header from '../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../GardenPopup/DeletePopup'
import { WTPPumpCategoryNoDDL } from '../../../../../../Components/CommonDDL/WTPPumpCategoryDDL'
import { WTPSumpNumberDDL } from '../../../../../../Components/CommonDDL/WTPSumpNumberDDL'
import { WTPPumpNumberDDL } from '../../../../../../Components/CommonDDL/WTPPumpNumberDDL'
import { useAuthState } from '../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import { Loading } from '../../../../../../Helper/Loading'
import { Pegination } from '../../../../../../Components/Pegination/Pegination'
import { WTPPumpMasterDeleteAPI, WTPPumpMasterTableDataAPI, WTPPumpMasterTableExportDataAPI } from '../../../../../../Redux/WTPDashboardSlice/WTPDashboardsSlice/WTPMasterData/WTPPumpMasterSlice'
import { WTPPumpMasterExportData } from './WTPPumpMasterExportPage'

export default function WTPPumpMasterPage() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [DeletePopupShow, setDeletePopupShow] = useState()
    const [WTPPumpMasterPagePopupShow, setWTPPumpMasterPagePopupShow] = useState()
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    const [PerPageCount, setPerPageCount] = useState(10)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)
    const [IsPost, setIsPost] = useState(false)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [Date, setDate] = useState(moment().format('YYYY-MM-DD'))

    const [Category, setCategory] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [SumpNumber, setSumpNumber] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [PumpNumberDDL, setPumpNumberDDL] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setWTPPumpMasterPagePopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setWTPPumpMasterPagePopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }

    const handleOnCloseClick = () => {
        setWTPPumpMasterPagePopupShow(false)
    }

    const handleClear = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsClear(!IsClear)
        setCategory({
            ...Category,
            ID: 0,
            Label: 'Select...',
        })
        setSumpNumber({
            ...SumpNumber,
            ID: 0,
            Label: 'Select...',
        })
        setPumpNumberDDL({
            ...PumpNumberDDL,
            ID: 0,
            Label: 'Select...',
        })

        // setFromDate(moment().startOf('month').format('YYYY-MM-DD'))
        // setToDate(moment().format('YYYY-MM-DD'))
        // setDate(moment().format('YYYY-MM-DD'))
    }

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)

    }
    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }
    }

    useEffect(() => {
        const data = {
            // ReadingDate: Date,
            M_WTP_PumpID: PumpNumberDDL.ID,
            M_WTP_SumpID: SumpNumber.ID,
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
        }
        dispatch(WTPPumpMasterTableDataAPI({ data }))
    }, [IsPost, To, isSearch, IsClear])
    const { tableData, isLoading } = useSelector(state => state.WTPPumpMasterTableData)

    useEffect(() => {
        const data = {
            M_WTP_PumpID: PumpNumberDDL.ID,
            M_WTP_SumpID: SumpNumber.ID,
            M_UserID: UserID,
            token: token,
            From: '1',
            To: "99999",
        }
        dispatch(WTPPumpMasterTableExportDataAPI({ data }))
    }, [IsPost, isSearch, IsClear])
    const { ExportTableData, isExportLoading } = useSelector(state => state.WTPPumpMasterTableExportData)

    const handleDeleteApi = (item) => {
        const data = {
            M_WTP_PumpID: item.m_wtP_PumpID,
            M_UserID: UserID,
            token: token,
            Flag: 'Delete',
            handleIsPost: handleIsPost
        }
        dispatch(WTPPumpMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.WTPPumpMasterDelete)

    return (
        <div>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>Pump Master</h5>
                                <div className="float-end butt">
                                {
                                        isExportLoading ?
                                            <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                <i
                                                    className="fa fa-refresh fa-spin"
                                                    style={{ marginRight: "5px" }}
                                                />Loading</button>
                                            :
                                            ExportTableData && ExportTableData.table && ExportTableData.table.length > 0 &&
                                            <WTPPumpMasterExportData
                                                ExcelData={ExportTableData}
                                                name='Pump Master'
                                                // searchName={searchName}
                                            />
                                    }
                                    <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i>
                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">
                                            <div className="col-lg-3 col-md-6">
                                                <WTPPumpCategoryNoDDL
                                                    Category={Category}
                                                    setCategory={setCategory}
                                                />

                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <WTPSumpNumberDDL
                                                    SumpNumber={SumpNumber}
                                                    setSumpNumber={setSumpNumber}
                                                    PlantName='0'
                                                // Flag='ward'
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <WTPPumpNumberDDL
                                                    PumpNumberDDL={PumpNumberDDL}
                                                    setPumpNumberDDL={setPumpNumberDDL}
                                                    Category={Category}
                                                    SumpNumber={SumpNumber}
                                                // Flag='ward'
                                                />

                                            </div>
                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-3">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Pump Category</th>
                                                        <th>Sump</th>
                                                        <th>Pump Number</th>
                                                        <th className='action_icon'>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                            <tr>
                                                                <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                <td>{item.pumpCategory ? item.pumpCategory : '-'}</td>
                                                                <td>{item.sumpNumber ? item.sumpNumber : '-'}</td>
                                                                <td>{item.pumpNumber ? item.pumpNumber : '-'}</td>
                                                                <td style={{ textAlign: "center" }}>
                                                                    <span>
                                                                        <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                            style={{ cursor: 'pointer' }}
                                                                            onClick={() => handleEditOnClick(item)}
                                                                        >
                                                                        </i>
                                                                    </span>
                                                                    <span>
                                                                        <DeletePopup
                                                                            open={DeletePopupShow}
                                                                            item={item}
                                                                            handleDeleteApi={handleDeleteApi}
                                                                        />
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        )) :
                                                            <td colSpan={15}>No data found</td>
                                                    }
                                                </tbody>
                                            </table>

                                        </div>
                                        {tableData && tableData.table && tableData.table.length > 0 &&
                                            <Pegination
                                                PerPageCount={PerPageCount}
                                                TotalCount={tableData.table[0].totalCount}
                                                setFrom={setFrom}
                                                setTo={setTo}
                                                setrowNo={setrowNo}
                                                CurrentPage={CurrentPage}
                                                setCurrentPage={setCurrentPage}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {
                    WTPPumpMasterPagePopupShow ?
                        <WTPPumpMasterPagePopup
                            open={WTPPumpMasterPagePopupShow}
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div>
        </div>



    )
}